import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Логируйте ошибку в какой-либо сервис
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Переход через navigate() здесь не поможет — это тот же React-дерево,
      // hasError никогда не сбросится обратно сам. Нужен полный reload,
      // чтобы приложение реально поднялось заново с чистого состояния.
      return (
        <div>
          <h1>Что-то пошло не так.</h1>
          <button onClick={() => { window.location.assign('/'); }}>Вернуться на главную</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
